enum AppEventTargetType {
    wholeApplication,
    specificObject
  }

export default AppEventTargetType;
